// extracted by mini-css-extract-plugin
export default {"buttonBg":"GradientButton_buttonBg__EIJI7"};